import { CheckCircle2, Clock, Package, RefreshCw, Shield, Users } from 'lucide-react';
import React, { useEffect, useMemo } from 'react';
import { useAppState } from '../../context/AppStateContext';
import { PageHeader } from '../common/PageHeader';
import { StatCard } from '../common/StatCard';

export const Dashboard = () => {
  const { users, products, loading, handleRefresh, loadUsers, loadProducts } = useAppState();

  // Refetch every time this tab is opened, not just once at login.
  useEffect(() => {
    loadUsers(undefined, true);
    loadProducts(undefined, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stats = useMemo(() => ({
    totalUsers: users.length,
    totalProducts: products.length,
    verifiedProducts: products.filter((p) => p.verificationStatus === 'verified').length,
    pendingProducts: products.filter((p) => p.verificationStatus === 'pending').length,
    fieldOfficers: users.filter((u) => u.role === 'Field Officer').length,
    dealers: users.filter((u) => u.role === 'Dealer').length,
    regularUsers: users.filter((u) => u.role === 'User').length,
  }), [users, products]);

  return (
    <div className="space-y-4">
      <PageHeader
        title="Dashboard Overview"
        subtitle="Aegis Verify verification system analytics"
        actions={
          <button
            onClick={handleRefresh}
            disabled={loading}
            className="inline-flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-medium bg-indigo-600 hover:bg-indigo-700 text-white transition-all duration-150 active:scale-[0.97] disabled:opacity-50 disabled:active:scale-100"
          >
            <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
            Refresh
          </button>
        }
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <StatCard title="Total Users" value={stats.totalUsers} change="+12%" changeType="positive" icon={Users} tone="bg-blue-600" delay={0} />
        <StatCard title="Total Products" value={stats.totalProducts} change="+8%" changeType="positive" icon={Package} tone="bg-emerald-600" delay={40} />
        <StatCard title="Verified Products" value={stats.verifiedProducts} change="+15%" changeType="positive" icon={CheckCircle2} tone="bg-teal-600" delay={80} />
        <StatCard title="Pending Verification" value={stats.pendingProducts} change="-5%" changeType="negative" icon={Clock} tone="bg-amber-600" delay={120} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <StatCard title="Field Officers" value={stats.fieldOfficers} icon={Shield} tone="bg-blue-600" delay={160} />
        <StatCard title="Dealers" value={stats.dealers} icon={Users} tone="bg-emerald-600" delay={200} />
        <StatCard title="Regular Users" value={stats.regularUsers} icon={Users} tone="bg-violet-600" delay={240} />
      </div>
    </div>
  );
};
